// Website builds use Hosting rewrites; local-file desktop builds need HTTPS.
export function playbackApiBase({
  production = process.env.NODE_ENV === 'production',
  origin = typeof window === 'undefined' ? '' : window.location.origin,
  functionsOrigin = process.env.REACT_APP_FUNCTIONS_ORIGIN,
  projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID,
} = {}) {
  if (production && /^https?:\/\//i.test(origin)) return origin.replace(/\/+$/, '') + '/api';
  return (functionsOrigin || `https://us-central1-${projectId}.cloudfunctions.net/api`).replace(/\/+$/, '');
}
